import { Match, MatchType, RouterContext } from "@cdv/jazz-ui";
import { Box } from "@mui/material";
import { ReactElement, useContext, useEffect } from "react";
import AppBar from "../ui/AppBar";
import { Resource } from "../utils";
import { translateField } from "@cdv/jazz-i18n";

export default function Content(): ReactElement {
  return (
    <>
      <AppBar title={translateField(Resource.User, "settings")} />
    </>
  );
}
